module.exports = __webpack_public_path__ + "static/media/塔香三杯魷魚鬚.ecd8a5bb.jpg";